<div style="page-break-inside: avoid;" *ngIf="isSourceFund" class="mt-4"
     [ngClass]="{'container': !isSinglePageReturn, 'return-view-backsground-print': !isSinglePageReturn && printActive, 'return-view-background': !isSinglePageReturn && !printActive}">
  <div class="row mb-4">
    <div class="col-12 text-center">
      <strong>PARTICULARS OF SOURCES OF FUND</strong><br/>
      <i>[Attachment for serial no 1 of IT-10B (2023)]</i>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-6"><strong>Taxpayer Name:</strong> {{ returnData?.profileData?.assesName }}</div>
    <div class="col-sm-6 text-right">
      <strong>Assessment Year:</strong> {{ returnData?.submissionInfo?.assessmentYear }}
    </div>
  </div>
  <div class="row mt-3 mb-5">
    <div class="col-sm-12">
      <strong>TIN</strong>&ensp;&ensp;
      <span class="ml-3" style="white-space: nowrap;">
                <input value="{{item}}" *ngFor="let item of returnData?.profileData?.tin.split('')"
                       class="input-default" disabled/>
            </span>
    </div>
  </div>

  <div style="page-break-inside: avoid" class="row mb-4">
    <div class="col-12 text-center mb-3 font-weight-bold">
      Sources of Fund
    </div>
    <div class="col-12">
      <table class="table table-bordered">
        <tbody>
        <tr>
          <td class="text-center">Sources</td>
          <td class="text-center">Particulars</td>
          <td class="text-center">Amount</td>
        </tr>
        <tr>

          <td class="text-start">Taxable Income (excluding non-cash benefits)</td>
          <td class="text-center"><b>-</b></td>
          <td class="text-right">{{ taxableIncome | currencySeparatorBD }}</td>
        </tr>
        <tr *ngFor="let item of taxExemptedIncome; let i = index">
          <td *ngIf="i === 0" class="text-start" [attr.rowspan]="taxExemptedIncome.length">
            Tax Exempted Income
          </td>
          <td [class]="item?.description == '-' ? 'text-center font-bold': 'text-start'">{{
              item?.description
            }}
          </td>
          <td class="text-right">{{ item?.value | currencySeparatorBD }}</td>
        </tr>

        <tr *ngFor="let item of otherReceipt; let i = index">

          <td *ngIf="i === 0" class="text-start" [attr.rowspan]="otherReceipt.length">
            Receipt of Gift and Others
          </td>
          <td [class]="item?.description == '-' ? 'text-center font-bold': 'text-start'">{{
              item?.description
            }} - {{ item?.relatedIN }}
          </td>
          <td class="text-right">{{ item?.value | currencySeparatorBD }}</td>

        </tr>

        </tbody>
      </table>

    </div>
  </div>
</div>
